import { SendNotificationValues } from 'models/notification';
import { sdk } from 'utils/query';
import { EmptyParametersError } from './errors/EmptyParametersError';
import { ObjectNotFoundError } from './errors/ObjectNotFoundError';

export const sendNotification = async ({ title, body, groupId, userId }: SendNotificationValues) => {
  if (!groupId || !userId || body === '') throw new EmptyParametersError();

  const notification = await sdk.notifications.create({ type: 'message', userId, fields: { title, body } });

  if (!notification.id) {
    throw new ObjectNotFoundError('Notification');
  }

  await sdk.profiles.logs.create(userId, groupId, { text: `${title}\n${body}` });
};
